export default __webpack_public_path__ + "static/media/gif.4c02db2b.gif";